import {TFunction} from 'i18next';

import {RecallAuditAffectedOrganization, RecallAuditPreviousStatus} from 'types/recall-audit';
import {formatDate} from 'utils/date';

export interface AuditCountItem {
    label: string;
    count?: string | number;
}

export const mapAffectedOrganizations = (
    value: RecallAuditAffectedOrganization[] = [],
): AuditCountItem[] =>
    value.map(({organizationId, codesCount}) => ({
        label: organizationId == null ? '—' : String(organizationId),
        count: codesCount,
    }));

export const mapPreviousStatuses = (value: RecallAuditPreviousStatus[] = []): AuditCountItem[] =>
    value.map(({status, count}) => ({
        label: status ?? '—',
        count,
    }));

export const translateUserRole = (t: TFunction, role?: string) => {
    if (!role) return '—';

    const roleKey = role.startsWith('ROLE_') ? role : `ROLE_${role}`;
    return t(`pages.recallAudit.userRoles.${roleKey}`, {defaultValue: role});
};

export const formatLocalDateTime = (value?: string, dateOnly = false) => {
    if (!value) return '—';

    const dateOnlyMatch = dateOnly && value.match(/^(\d{4})-(\d{2})-(\d{2})$/);
    if (dateOnlyMatch) {
        const [, year, month, day] = dateOnlyMatch;
        return `${day}.${month}.${year}`;
    }

    const date = new Date(value);
    return Number.isNaN(date.getTime())
        ? value
        : formatDate(date, dateOnly ? 'dd.MM.yyyy' : 'dd.MM.yyyy, HH:mm:ss');
};
